<template>
  <div class="clientInvoices">
    <div class="pageContent">
      <heading type="h1">Client Invoices</heading>
      <spinner v-if="loading" />
      <search-box v-model="search" name="invoices..." />
      <invoice-table :tableData="filteredInvoices" />
    </div>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'
import ClientLogo from '@/components/ClientLogo/client-logo'
import Spinner from '@/components/SpinnerIcon/spinner'
import SearchBox from '@/components/SearchBox/searchbox'
import InvoiceTable from '@/components/InvoiceTable/invoice-table'
import {notificationMixin} from '@/mixins/notificationMixin'
import {invoiceMixin} from '@/mixins/invoiceMixin'
import {modalMixin} from '@/mixins/modalMixin'

export default {
  name: 'ClientInvoices',
  mixins: [notificationMixin, modalMixin, invoiceMixin],
  components: {
    Heading,
    ClientLogo,
    Spinner,
    SearchBox,
    InvoiceTable
  },
  created () {
    this.startLoading()
    this.getClientInvoices(this.$route.params.id).then(() => {
      this.finishLoading()
    }, error => {
      this.finishLoading()
      this.addNotification('danger', error)
    })
  },
  data: () => ({
    search: ''
  }),
  computed: {
    filteredInvoices () {
      return this.clientInvoices.filter(invoice => {
        return invoice.client.name.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  mounted () {},
  methods: {}
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/pages/client/client-invoices.vue